import React from 'react'

interface PreviewHeaderProps {
    title?: string
    showIcon?: boolean
    style?: React.CSSProperties
}

export function PreviewHeader({ title = "Preview", showIcon = true, style = {} }: PreviewHeaderProps) {
    return (
        <div className="preview-header" style={{
            padding: '20px',
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            ...style
        }}>
            <h3 style={{ margin: 0, color: '#666' }}>
                {showIcon && <i className="fas fa-eye" style={{ marginRight: '8px' }}></i>}
                {title}
            </h3>
        </div>
    )
}